import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const WifiLowFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 19.6L9 16.36C9.78 15.62 10.94 15.1 12 15.1C13.06 15.1 14.22 15.62 15 16.36L12 19.6Z" />
    </SvgIcon>
  );
});
